import { computed, onMounted, onUnmounted, ref } from "vue";
import { THEME_ATTRIBUTE } from "@/src/shared/constants/theme";

const HIGH_CONTRAST_THEME_TOKEN = "contrast-high";
const themeTokens = ref<string[]>([]);
const isHighContrast = computed(() => themeTokens.value.includes(HIGH_CONTRAST_THEME_TOKEN));

let observer: MutationObserver | undefined;
let subscribers = 0;

function syncThemeTokens() {
  if (typeof document === "undefined") {
    themeTokens.value = [];
    return;
  }

  themeTokens.value = (document.documentElement.getAttribute(THEME_ATTRIBUTE) ?? "").split(/\s+/).filter(Boolean);
}

function startObservingTheme() {
  syncThemeTokens();

  if (observer || typeof MutationObserver === "undefined") {
    return;
  }

  observer = new MutationObserver(syncThemeTokens);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: [THEME_ATTRIBUTE],
  });
}

function stopObservingTheme() {
  observer?.disconnect();
  observer = undefined;
}

export const useThemeStore = () => {
  syncThemeTokens();

  onMounted(() => {
    subscribers += 1;

    if (subscribers === 1) {
      startObservingTheme();
    }
  });

  onUnmounted(() => {
    subscribers = Math.max(0, subscribers - 1);

    if (subscribers === 0) {
      stopObservingTheme();
    }
  });

  return {
    isHighContrast,
  };
};
